export function setLocalStorageItems(items) {
  for (const key in items) {
    localStorage.setItem(key, items[key]);
  }
}
